export default __webpack_public_path__ + "static/media/settings.857a6a73.svg";